import {
  Page,
  Layout,
  Card,
  BlockStack,
  SkeletonBodyText,
  SkeletonDisplayText,
  Box,
  InlineStack,
} from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { AppPageWrapper } from "@shared/ui";

export default function EventDetailsSkeleton() {
  const { t } = useTranslation();

  return (
    <AppPageWrapper>
      <Page
        fullWidth
        backAction={{ content: t("common.back"), onAction: () => {} }}
        title=""
        subtitle=""
      >
        <BlockStack gap="400">
          {/* Page header skeleton */}
          <Card>
            <Box padding="400">
              <BlockStack gap="300">
                <SkeletonDisplayText size="large" />
                <SkeletonDisplayText size="small" />
                <InlineStack gap="200">
                  <Box width="100px">
                    <SkeletonBodyText lines={1} />
                  </Box>
                  <Box width="100px">
                    <SkeletonBodyText lines={1} />
                  </Box>
                </InlineStack>
              </BlockStack>
            </Box>
          </Card>

          <Layout>
            <Layout.Section>
              <Card>
                <BlockStack gap="400">
                  <Box>
                    <SkeletonDisplayText size="medium" />
                  </Box>

                  <InlineStack gap="400">
                    <Box width="50%">
                      <BlockStack gap="200">
                        <SkeletonDisplayText size="small" />
                        <SkeletonBodyText lines={1} />
                      </BlockStack>
                    </Box>
                    <Box width="50%">
                      <BlockStack gap="200">
                        <SkeletonDisplayText size="small" />
                        <SkeletonBodyText lines={1} />
                      </BlockStack>
                    </Box>
                  </InlineStack>

                  <BlockStack gap="200">
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={1} />
                  </BlockStack>

                  <InlineStack gap="400">
                    <Box width="50%">
                      <BlockStack gap="200">
                        <SkeletonDisplayText size="small" />
                        <SkeletonBodyText lines={4} />
                      </BlockStack>
                    </Box>
                    <Box width="50%">
                      <BlockStack gap="200">
                        <SkeletonDisplayText size="small" />
                        <SkeletonBodyText lines={4} />
                      </BlockStack>
                    </Box>
                  </InlineStack>
                </BlockStack>
              </Card>
            </Layout.Section>

            <Layout.Section variant="oneThird">
              <Layout>
                <Layout.Section>
                  <Card>
                    <BlockStack gap="300">
                      <InlineStack gap="200" blockAlign="center">
                        <Box width="20px">
                          <SkeletonBodyText lines={1} />
                        </Box>
                        <SkeletonDisplayText size="small" />
                      </InlineStack>

                      <InlineStack gap="200" blockAlign="center">
                        <Box width="20px">
                          <SkeletonBodyText lines={1} />
                        </Box>
                        <SkeletonDisplayText size="small" />
                      </InlineStack>

                      <BlockStack gap="200">
                        <SkeletonDisplayText size="small" />
                        <SkeletonBodyText lines={1} />
                      </BlockStack>
                    </BlockStack>
                  </Card>
                </Layout.Section>

                <Layout.Section>
                  <Card>
                    <BlockStack gap="300">
                      <SkeletonDisplayText size="medium" />

                      <InlineStack gap="200" blockAlign="center">
                        <Box width="20px">
                          <SkeletonBodyText lines={1} />
                        </Box>
                        <SkeletonDisplayText size="small" />
                      </InlineStack>

                      <InlineStack gap="200" blockAlign="center">
                        <Box width="20px">
                          <SkeletonBodyText lines={1} />
                        </Box>
                        <SkeletonDisplayText size="small" />
                      </InlineStack>

                      <SkeletonBodyText lines={1} />
                    </BlockStack>
                  </Card>
                </Layout.Section>

                <Layout.Section>
                  <Card>
                    <BlockStack gap="300">
                      <SkeletonDisplayText size="medium" />
                      <SkeletonBodyText lines={3} />
                      <SkeletonDisplayText size="small" />
                    </BlockStack>
                  </Card>
                </Layout.Section>
              </Layout>
            </Layout.Section>
          </Layout>
        </BlockStack>
      </Page>
    </AppPageWrapper>
  );
}
